<template>
  <v-card flat dark>
    <v-row no-gutters class="mt-5">
      <v-col cols="12" class="d-flex justify-content-center">
        <user-profilepicture
          class="mt-5"
          @updatedPicture="updateUserPicture"
          :width="120"
          :height="120"
          v-if="user"
          :picture="user.bild"></user-profilepicture>
        <user-menu v-if="user" :user="user"></user-menu>
      </v-col>

      <v-col cols="12" class="d-flex justify-center">
        <v-card-title class="font-weight-bold h5 mt-2" v-if="user">
          {{ user.vorname }} {{ user.nachname }}
          <v-icon class="pl-2" color="primary">mdi-check-decagram</v-icon>
        </v-card-title>
      </v-col>
      <v-col cols="12" class="mb-5">
        <v-row no-gutters class="mt-0"><user-training-stats :user="user"></user-training-stats></v-row>
      </v-col>
      <v-col cols="12"><contract-profile-card></contract-profile-card></v-col>
      <v-col cols="12" v-if="contracts.length > 0" class="px-4 mb-4">
        <div class="text-overline grey--text mb-2">Aktuelle Vorgänge</div>

        <v-card
          v-for="(con, i) in contracts"
          :key="i"
          dark
          flat
          class="rounded-xl mb-3 border-primary"
          style="border: 1px solid rgba(25, 118, 210, 0.3); background: rgba(25, 118, 210, 0.05)">
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar color="primary" size="40" class="mr-4">
              <v-icon color="white">{{ con.qrPaymentStatus === "open" ? "mdi-receipt" : "mdi-clock-fast" }}</v-icon>
            </v-avatar>

            <div style="flex-grow: 1">
              <div class="text-body-2 font-weight-bold">
                {{ con.qrPaymentStatus === "open" ? "Offene Rechnung" : "Vertrag in Prüfung" }}
              </div>
              <div class="text-caption grey--text text--lighten-1">
                {{ con.qrPaymentStatus === "open" ? "Bitte begleiche den Betrag via QR-Rechnung" : "Wir checken gerade deine Unterlagen" }}
              </div>
            </div>

            <v-btn v-if="con.qrPaymentStatus === 'open'" icon color="success" @click="downloadQRInvoice(user._id, con.index, user.nachname)">
              <v-icon>mdi-download</v-icon>
            </v-btn>

            <v-chip v-else x-small color="orange" outlined class="font-weight-bold"> BEARBEITUNG </v-chip>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-btn-toggle v-model="selected" mandatory class="custom-toggle">
          <v-btn
            v-for="(item, index) in items"
            :key="item"
            class="custom-btn rounded-lg mx-1"
            :disabled="item === 'Vertrag' && !transactions && !nutrition">
            <span :class="{ 'custom-toggle--active': index === selected }" style="z-index: 100">
              {{ item }}
            </span>
          </v-btn>
          <span class="highlight" :class="{ left: selected === 0, right: selected === 1 }"></span>
        </v-btn-toggle>
        <v-tabs-items dark classt="mt-2" v-model="selected">
          <v-tab-item v-for="(item, index) in items" :key="index + 'tab'" :value="index">
            <user-profile-training-card
              @showUpgrade="showUpgradeDialog"
              v-if="item === 'Meine Fitness'"
              :user="user"
              :isCenterAccount="isCenterAccount"></user-profile-training-card>
            <user-profile-contract-card
              ref="trainingCard"
              v-if="item === 'Vertrag'"
              :transactions="transactions"
              :isCenterAccount="isCenterAccount"
              :nutrition="nutrition"
              :user="user"
              :studio="studio"
              :contractInformations="contractInformations.MemberDetail"></user-profile-contract-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col v-if="transactions && false" class="justify-content-center text-center" cols="12">
        <!-- @click="$router.push({ name: 'userPayments' })" -->
        <v-chip x-large color="primary" class="font-weight-bold">
          Badge Guthaben: {{ transactions.balance ? formatCurrency1(transactions.balance) : 0 }} CHF
        </v-chip>
      </v-col>

      <v-col cols="12" class="py-0 my-0">
        <payment-home></payment-home>
      </v-col>
    </v-row>
    <v-dialog v-model="showContractCreatedDialog" transition="dialog-bottom-transition" max-width="500" persistent>
      <v-card class="rounded-xl overflow-hidden">
        <v-sheet color="primary" dark class="pa-8 text-center">
          <v-avatar color="white" size="70" class="mb-4 elevation-4">
            <v-icon color="primary" size="40">mdi-party-popper</v-icon>
          </v-avatar>
          <div class="text-h5 font-weight-black">Willkommen im Team!</div>
          <div class="text-subtitle-2 opacity-80">Dein Vertrag wurde erfolgreich erstellt.</div>
        </v-sheet>

        <v-card-text class="pt-6 pb-2 text-body-1 grey--text text--darken-3">
          Hallo {{ user?.vorname || "Dom" }}, <br />
          Mega, dass du dabei bist! Unsere Administration prüft jetzt deine Daten. Sobald das erledigt ist, bist du ganz offiziell Teil der
          <strong>{{ studio.art.replace("AG", "") }}-Community</strong>. Wir geben dir Bescheid!

          <v-card v-if="referralActive" color="orange lighten-5" flat class="rounded-lg pa-4 mt-6 border-orange">
            <div class="d-flex align-center mb-2">
              <v-icon color="orange darken-3" class="mr-2">mdi-cash-multiple</v-icon>
              <span class="font-weight-black orange--text text--darken-4">Cash-Bonus sichern!</span>
            </div>
            <p class="text-body-2 mb-3">
              Lade Freunde oder Familie zu einem 11-tägigen Gratis-Training ein. Schliessen sie ab, kriegst du
              <strong>CHF {{ leadSetting.price.value }}.- bar auf die Hand!</strong>
            </p>
            <v-btn block color="orange darken-2" dark depressed class="rounded-pill" @click="$router.push('/referral')">
              Jetzt weiterempfehlen
            </v-btn>
          </v-card>

          <div v-if="studio.email || studio.telefon" class="mt-6 text-caption text-center grey--text">
            Fragen?
            <span v-if="studio.telefon"
              >Ruf uns an: <strong>{{ studio.telefon }}</strong> <br />Oder
            </span>
            <span v-if="studio.email">
              schreib an: <strong>{{ studio.email }}</strong>
            </span>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <div class="text-center pb-4 px-4" v-if="contracts.length > 0 && contracts[contracts.length - 1].qrPaymentStatus === 'open'">
          <p class="text-body-2 font-weight-bold mb-2">Deine erste Rechnung steht bereit:</p>
          <v-btn
            color="success"
            block
            outlined
            class="rounded-pill"
            @click="downloadQRInvoice(user._id, contracts[contracts.length - 1].index, user.nachname)">
            <v-icon left>mdi-receipt</v-icon> QR-Rechnung herunterladen
          </v-btn>
        </div>
        <v-card-actions class="pa-4">
          <v-btn block x-large text color="primary" class="font-weight-bold" @click="showContractCreatedDialog = false"> Alles klar, danke! </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <verify-email @verifying="verifying = true" v-model="forceVerifyEmail" @emailVerified="forceVerifyEmail = false"></verify-email>
  </v-card>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex"
import UserMenu from "@/views/user/components/UserMenu.vue"

import UserProfilepicture from "@/views/user/components/UserProfilepicture.vue"
import UserWeightCard from "@/views/user/components/UserWeightCard.vue"
import UserCheckinCard from "@/views/user/components/UserCheckinCard.vue"
import UserTrainingStats from "@/views/user/components/UserTrainingStats.vue"
import PaymentHome from "@/views/dashboard/payment/PaymentHome.vue"
import PurchasesProfileButton from "@/views/shop/PurchasesProfileButton.vue"
import VerifyEmail from "@/components/verification/verifyEmail.vue"
import UserPayments from "./views/UserPayments.vue"
import UserProfileTrainingCard from "./views/UserProfileTrainingCard.vue"
import UserProfileContractCard from "./views/UserProfileContractCard.vue"
import ContractProfileCard from "@/views/dashboard/contract/v2/ContractProfileCard.vue"
import { formatCurrency } from "@/moduls/currency/currency.js"

import api from "@/api"
export default {
  name: "UserProfile",

  data() {
    return {
      selected: 0,
      items: ["Vertrag", "Meine Fitness"],
      verifying: false,
      forceVerifyEmail: false,
      showContractCreatedDialog: false,
      user: null,
      userBackup: null,
      referralActive: false,
      leadSetting: { price: { value: 0 } },
      studio: {
        art: "Fitness",
        telefon: "",
        email: "",
      },
      transactions: null,
      nutrition: null,
      transactionsDialog: false,
      contractInformations: {},
      studioAccountsMap: [
        "frauenfeld@wellcomefit.ch",
        "wallisellen@wellcomefit.ch",
        "basel@wellcomefit.ch",
        "wetzikon@wellcomefit.ch",
        "dietlikon@wellcomefit.ch",
        "netstal@wellcomefit.ch",
        "schwanden@wellcomefit.ch",
        "niederurnen@wellcomefit.ch",
        "steckborn@wellcomefit.ch",
        "stgallenwest@wellcomefit.ch",
        "st.gallen@wellcomefit.ch",
        "einstein@wellcomefit.ch",
        "arbon@wellcomefit.ch",
        "obfelden@wellcomefit.ch",
        "herisau@wellcomefit.ch",
        "sirnach@wellcomefit.ch",
        "rikon@wellcomefit.ch",
        "oerlikon@wellcomefit.ch",
        "buelach@wellcomefit.ch",
        "winterthur@wintifit.ch",
        "pfungen@wintifit.ch",
        "wil@wellcomefit.ch",
        "frauenfeldwest@wellcomefit.ch",
        "kreuzlingen@wellcomefit.ch",
        "muri@wellcomefit.ch",
      ],
      isCenterAccount: false,
      contracts: [],
    }
  },
  components: {
    ContractProfileCard,
    UserProfileTrainingCard,
    UserProfileContractCard,
    UserProfilepicture,
    UserWeightCard,
    UserCheckinCard,
    UserTrainingStats,
    UserMenu,
    PaymentHome,
    PurchasesProfileButton,
    VerifyEmail,
    UserPayments,
  },
  mounted() {
    if (this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  beforeDestroy() {
    if (!this.navigationVisible) this.toggleNavigationBarVisibility()
  },
  async created() {
    this.fetchUserContracts()
    if (this.$route.query.hasOwnProperty("contractCreated")) {
      try {
        console.log("")
      } catch (e) {
        console.log("error fetching qr code bills")
      }
      setTimeout((e) => {
        this.showContractCreatedDialog = true
      }, 3000)
    }
    let status = await api.fetchUserEmailVerificationStatus()
    await this.fetchUser()
    if (status.verified || this.isCenterAccount) {
      this.fetchNutrition()
      let fetchedTrans = await api.fetchAccountTransactionsForUser()
      if (fetchedTrans.error && !this.isCenterAccount && this.contracts.length === 0) {
        alert(
          "Hoppla! Wir haben leider keine Mitgliedschaft für die E-Mail-Adresse: " +
            this.user.email +
            " gefunden. Das könnte daran liegen, dass du in der roody App vielleicht eine andere E-Mail-Adresse verwendet hast als die, die in deinem Vertrag hinterlegt ist.  Schnapp dir einfach die Trainer in deinem Studio, die bringen das im Handumdrehen in Ordnung.",
        )
      } else {
        this.transactions = fetchedTrans
      }
      this.contractInformations = await api.fetchTACMemberOwnContract()
    } else {
      // ÄNDERN UNBEDING!!
      this.forceVerifyEmail = true
    }
    this.fetchStudioAndReferral()
  },

  methods: {
    ...mapActions("navigationStoreNotPersisted", ["toggleNavigationBarVisibility", "setNavigationBarText", "setNavigationbarVisibility"]),
    async downloadQRInvoice(userId, index, nachname) {
      try {
        this.$toast.info("Rechnung wird generiert...")
        await api.downloadQRInvoicePDF(userId, index, nachname)
        this.$toast.success("Download gestartet!")
      } catch (e) {
        this.$toast.error("Fehler beim Download")
      }
    },
    async fetchUserContracts() {
      try {
        let contracts = await api.fetchOwnContracts()
        this.contracts = contracts
      } catch (e) {
        console.log("error fetching user contracts")
      }
    },
    showUpgradeDialog() {
      this.$refs.trainingCard[0].showContractDialog = true
    },
    async fetchNutrition() {
      try {
        let nutritionContract = await api.fetchOwnNutritionContract()
        if (nutritionContract.verified && nutritionContract.nutrition) {
          this.nutrition = nutritionContract.nutrition
          console.log(this.nutrition)
        }
      } catch (e) {
        console.log(e)
        console.log("Error fetching nutrition contract")
      }
    },
    logout() {
      if (confirm("Möchtest du dich wirklich ausloggen?") === false) return
      localStorage.removeItem("token")
      localStorage.removeItem("user")

      location.reload()
    },
    formatCurrency1(value) {
      return formatCurrency(value)
    },
    newTargetWeight(val) {
      this.user.targetWeight = val
    },

    updateUserPicture(name) {
      this.user.bild = name
    },
    async fetchStudioAndReferral() {
      let studio = await api.getUserStudio()
      studio = studio.studio
      this.studio = studio
      if (studio && studio.leadSetting && studio.leadSetting.active) {
        this.referralActive = true
        this.leadSetting = studio.leadSetting
      } else {
        this.referralActive = false
      }
    },
    async fetchUser() {
      try {
        let user = await api.getUser()
        this.user = user.user

        if (this.studioAccountsMap.includes(this.user.email.toLowerCase())) {
          this.isCenterAccount = true
        }

        localStorage.setItem("user", JSON.stringify({ user: user.user }))

        this.userBackup = JSON.parse(JSON.stringify(user.user))
      } catch (e) {
        console.log(e)
        this.$toast.error("Fehler beim Laden")
      }
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationItems", "navigationVisible"]),
    getStudioName() {
      let name = "Fitness"
      if (this.user && this.user.studio_id) {
        if (this.user.studio_id === "pfungen" || this.user.studio_id === "winterthur") name = "winti FIT"
        else name = "well come FIT"
      }
      return name
    },
    userAge() {
      let age = "-"
      if (this.user && this.user.geburtstag) {
        age = this.$moment().diff(this.$moment(this.user.geburtstag), "years")
      }
      return age
    },
    bmiValue() {
      return ((Number(this.userWeight) / (Number(this.user.groesse) * Number(this.user.groesse))) * 10000).toFixed(2)
    },
    bmiColor() {
      if (this.bmiValue < 18.5) return "color: 'cornflowerblue';"
      if (this.bmiValue < 24) return " color: 'limegreen'; "
      if (this.bmiValue < 30) return " color: 'green'; "
      if (this.bmiValue < 35) return " color: 'orange'; "
      if (this.bmiValue < 40) return " color: 'darkgoldenrod'; "
      return "color: 'red'; "
    },
    userWeight() {
      if (this.user.weights && this.user.weights.length) return this.user.weights[this.user.weights.length - 1].value
      if (this.user.gewicht) {
        return this.user.gewicht
      }
      return 0
    },
  },
}
</script>

<style scoped lang="scss">
.button-switcher {
  position: relative;
  width: 300px;
  /* Adjust the width as needed */
}

.custom-toggle {
  position: relative;
  width: 100%;
}

.custom-btn {
  flex: 1 1 50%;
  color: white;
  /* Text color */
  font-weight: bold;
  border: 3px solid white;
  transition: color 0.3s;
}

.highlight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 50%;
  background-color: #656565;
  /* Highlight color */
  border-radius: 8px;
  transition: all 0.3s ease;
}

.highlight.right {
  left: 50%;
}

.highlight.left {
  left: 0;
}

.custom-toggle--active {
  color: #fff !important;
  /* Active text color */
}

::v-deep .slim-btn-edit {
  display: none;
}
</style>
